<div class="container">
    <app-section-header title="Notifications" [actionsTemplate]="actionsTemplate" [iconName]="'notifications'">
        <ng-template #actionsTemplate>
            <div class="actions">
                <button class="primary-btn" (click)="markAllAsRead()" [disabled]="!hasUnread">Mark all as read</button>
                <app-kebab-menu>
                    <button role="menuitem" class="resetStyles" (click)="onEdit()">Edit</button>
                </app-kebab-menu>
            </div>
        </ng-template>
    </app-section-header>

    <div class="notificationsContainer">
        @if (noResults) {
            <ng-container #noResults>
                <lib-no-data
                    [iconName]="'emptyNotifications'"
                    [title]="'No notifications yet.'"
                    [text]="'Notifications about your activity will show up here.'"
                ></lib-no-data>
            </ng-container>
        } @else {
            <app-notifications-list
                [notifications]="notifications"
                [(paginationConfig)]="paginationConfig"
                (paginationConfigChange)="refreshListView()"
                [isPanel]="false"
            >
            </app-notifications-list>
        }
    </div>
</div>
